const NOTICE_KEY = 'pgx-security-notice';

export const TERMINAL_SESSION_CODES = [
  'SESSION_ENVIRONMENT_CHANGED',
  'SESSION_IP_CHANGED',
  'TWO_FA_SETUP_REQUIRED',
] as const;

export type TerminalSessionCode = (typeof TERMINAL_SESSION_CODES)[number];

export const isTerminalSessionCode = (code: string | undefined): code is TerminalSessionCode =>
  TERMINAL_SESSION_CODES.some((item) => item === code);

export function rememberSecurityNotice(code: TerminalSessionCode): void {
  sessionStorage.setItem(NOTICE_KEY, code);
}

export function consumeSecurityNotice(): TerminalSessionCode | null {
  const value = sessionStorage.getItem(NOTICE_KEY);
  sessionStorage.removeItem(NOTICE_KEY);
  if (value && isTerminalSessionCode(value)) {
    return value;
  }
  return null;
}
